import { fromJS } from "immutable"

const initFssData = fromJS({
  
})


const initFilterDataFss= fromJS({
  invoiceNo:'',
  clientName:'',
  customerName:'',
  pageNo:1,
  pageSize:10,
})

export function fssData(
  state = initFssData,
  action
) {
  switch (action.type) {
    case "FSS_FETCH_DATA_SUCCESS":
      return fromJS(action.dataFss);
    default:
      return state;
  }
}


export function filterDataFss(
  state = initFilterDataFss,
  action
){
  switch (action.type) {
    case "FILTER_SET_INVOICE_NO_SUCCESS":
      return state.set('invoiceNo', action.invoiceNo)
    case "FILTER_SET_CLIENT_NAME_SUCCESS":
      return state.set('clientName', action.clientName)
    case "FILTER_SET_CUSTOMER_NAME_SUCCESS":
      return state.set('customerName', action.customerName)
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set('pageNo', action.pageNo)
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set('pageSize', action.pageSize)
    default:
      return state;
  }
 
}


export function approvalFssDetail(
  state= fromJS([]),
  action
){
  switch (action.type) {
    case "APPROVAL_FSS_DETAIL_FETCH":
      return fromJS(action.detail);
    default:
      return state;
  }
}

export function valueFssData(state = fromJS([]), action) {
  switch (action.type) {
    case "VALUE_FSS_DATA_SUCCESS":
      return fromJS(action.detail);
    default:
      return state;
  }
}

